type HeadingProps = {
  text: string;
  customStyle?: string;
};

export default function Heading({ text, customStyle }: HeadingProps) {
  return (
    <h1 className={`text-3xl lg:text-4xl font-bold my-2 ${customStyle}`}>
      {text}
    </h1>
  );
}
